import { RunState } from './model/run-state.model';

const stateWrapper: {
    runState: RunState | null;
} = {
    runState: null,
};

export const currentRunState = (): RunState => stateWrapper.runState;

export const defaultRunState = (): void => {
    stateWrapper.runState = {};
};
